export default "__VITE_ASSET__7197f8f5__"